// src/context/AlunoContext.js
import React, { createContext, useState, useEffect } from "react";

export const AlunoContext = createContext();

export const AlunoProvider = ({ children }) => {
  const [alunos, setAlunos] = useState([]);
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [desativados, setDesativados] = useState([]);


 const fetchAlunos = async () => {
  setCarregando(true);
  try {
    // Busca alunos ativos
    const resAtivos = await fetch("/api/alunos/ativos");
    if (!resAtivos.ok) throw new Error("Erro ao buscar alunos ativos.");
    let ativosData = await resAtivos.json();
    if (!Array.isArray(ativosData)) ativosData = [];

    // Busca alunos pré-registrados
    const resPre = await fetch("/api/alunos/pre-registrados");
    if (!resPre.ok) throw new Error("Erro ao buscar pré-registrados.");
    let preData = await resPre.json();
    if (!Array.isArray(preData)) preData = [];

    // Busca alunos desativados
    const resDes = await fetch("/api/alunos/desativados");
    if (!resDes.ok) throw new Error("Erro ao buscar desativados.");
    let desData = await resDes.json();
    if (!Array.isArray(desData)) desData = [];

    // Combina todos os dados
    const todos = [...ativosData, ...preData, ...desData];

    setAlunos(todos);
    setAtivos(ativosData);
    setInativos(preData);
    setDesativados(desData);

  } catch (err) {
    console.error("❌ Erro ao buscar alunos:", err);
    setAlunos([]);
    setAtivos([]);
    setInativos([]);
    setDesativados([]);
  } finally {
    setCarregando(false);
  }
};


  const ativarAluno = async (id) => {
    try {
      const res = await fetch(`/api/alunos/${id}/ativar`, {
        method: "PATCH",
      });

      if (!res.ok) {
        const erro = await res.json();
        throw new Error(erro.message || "Erro ao ativar aluno.");
      }

      await res.json();
      fetchAlunos();
    } catch (error) {
      console.error("❌ Erro ao ativar aluno:", error);
      throw error;
    }
  };

 const desativarAluno = async (id) => {
  try {
    const res = await fetch(`/api/alunos/${id}/desativar`, {
      method: "PATCH",
    });

    if (!res.ok) {
      const erro = await res.json();
      throw new Error(erro.message || "Erro ao desativar aluno.");
    }

    const resultado = await res.json();
    console.log("✅ Aluno desativado:", resultado);
    alert("Aluno desativado com sucesso!");
    fetchAlunos();
  } catch (error) {
    console.error("❌ Erro ao desativar aluno:", error);
    alert("Erro ao desativar aluno: " + error.message);
  }
};

const eliminarAluno = async (id) => {
  try {
    const res = await fetch(`/api/alunos/${id}`, {
      method: "DELETE",
    });

    if (!res.ok) {
      const erro = await res.json();
      throw new Error(erro.message || "Erro ao eliminar aluno.");
    }

    const resultado = await res.json();
    console.log("✅ Aluno eliminado:", resultado);
    fetchAlunos(); // Atualiza os dados após remoção
  } catch (error) {
    console.error("❌ Erro ao eliminar aluno:", error);
    throw error; // Para que o componente mostre erro também
  }
};


  useEffect(() => {
    fetchAlunos();
    const interval = setInterval(fetchAlunos, 15000); // Atualiza a cada 15 segundos
    return () => clearInterval(interval);
  }, []);

  return (
    <AlunoContext.Provider
  value={{
    alunos,
    ativos,
    inativos, // <-- isto é o que usamos no componente
    desativados,  // <-- novo
    carregando,
    fetchAlunos,
    ativarAluno,
    desativarAluno,
    eliminarAluno,
  }}
>
      {children}
    </AlunoContext.Provider>
  );
};
